module.exports = __webpack_public_path__ + "img/pic30.1f853f7d.png";